import React, { Component, Fragment } from "react";
import IconButton from './IconButton'
import { ExcelExport, ExcelExportColumn } from "@progress/kendo-react-excel-export";
import ConsultaSituacaoAcomp from "../../acompanhamento/components/ConsultaSituacaoAcomp";

export default class ExportToXls extends Component {

    constructor(props) {
        super(props)
        this.exporter = null
    }

    export = () => {
        this.exporter.save();
    }

    render() {
        const { dataSource, filename, columns, label } = this.props
        const length = (dataSource) ? dataSource.length : 0
        const desabilita = length === 0

        if (length) {
            const fields = columns.filter(f => f.format)
            if (fields && fields.length > 0)
                dataSource.forEach(e => { fields.forEach(f => { e[f.dataField] = f.format(e[f.dataField]) }); });
        }

        return (
            <Fragment>
                <IconButton icon="file-excel" text={label || "Baixar XLS"} size="md" disabled={desabilita} onClick={this.export} />

                <ExcelExport
                    data={dataSource}
                    fileName={filename}
                    ref={(exp) => { this.exporter = exp }} >
                    {columns.map((column, x) => <ExcelExportColumn key={x} title={column.text} field={column.dataField} />)}
                </ExcelExport>
            </Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/comum/components/ExportToXls.js